import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const ChassisNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const regExp = /^[A-HJ-NPR-Za-hj-npr-z\d]{8}[\dX][A-HJ-NPR-Za-hj-npr-z\d]{2}\d{6}$/;
  return control?.value && !regExp?.test(control?.value) ? { chassisnumber: true } : null;
};